var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcademia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "School-Exam-A--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "School Exam A Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 5.5a0.76 0.76 0 0 0 -0.75 0.75v0.25a0.5 0.5 0 0 0 0.5 0.5h0.5a0.5 0.5 0 0 0 0.5 -0.5v-0.25a0.76 0.76 0 0 0 -0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5a2 2 0 0 0 -2 2v20a2 2 0 0 0 2 2h8.64a2 2 0 0 0 1.28 -0.46l5.36 -4.47a2 2 0 0 0 0.72 -1.54V2a2 2 0 0 0 -2 -2Zm-8.5 19h-3a0.75 0.75 0 0 1 0 -1.5h3a0.75 0.75 0 0 1 0 1.5Zm4.5 -4H7.5a0.75 0.75 0 0 1 0 -1.5H15a0.75 0.75 0 0 1 0 1.5Zm2 -5a0.75 0.75 0 0 1 -1.5 0V9a0.5 0.5 0 0 0 -0.5 -0.5h-0.5a0.5 0.5 0 0 0 -0.5 0.5v1a0.75 0.75 0 0 1 -1.5 0V6.25a2.25 2.25 0 0 1 4.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcademia);
export default ForwardRef;